import { useCallback } from "react";

export default function useGetSupport() {
  const getSupport = useCallback(() => {
    if (typeof (window as any).Intercom === "function") return (window as any).Intercom("showNewMessage");

    if (process.env.NODE_ENV === "development") {
      alert("This would show intercom chat in production!");
      return;
    }

    window.open("mailto:support@upscope.com");
  }, []);

  return { getSupport };
}
